import React from "react"
import { useStaticQuery, graphql } from "gatsby"

const HomeClients = () => {
  const data = useStaticQuery(graphql`
    query {
      wpContentSettings(id: { eq: "cG9zdDoyMQ==" }) {
        home {
          logoOne {
            altText
            sourceUrl
          }
          logoTwo {
            altText
            sourceUrl
          }
          logoThree {
            altText
            sourceUrl
          }
          logoFour {
            altText
            sourceUrl
          }
          logoFive {
            altText
            sourceUrl
          }
          logoSix {
            altText
            sourceUrl
          }
          logoSeven {
            altText
            sourceUrl
          }
          logoEight {
            altText
            sourceUrl
          }
          logoNine {
            altText
            sourceUrl
          }
          logoTen {
            altText
            sourceUrl
          }
        }
      }
    }
  `)

  const clients = Object.values(data.wpContentSettings.home)
  const padRange = ["p-4", "", "p-3", "p-2", "p-4", "p-3", "", "", "p-2", "p-2"]

  return (
    <div className="row mt-12 gx-lg-8 gx-xl-12 gy-10 gy-lg-0 ">
      <div className="col-lg-12">
        <div className="row row-cols-3 row-cols-md-5 gx-0 gx-md-8 gx-xl-12 gy-11 mt-n10">
          {clients.map((client, index) =>
            client ? (
              <div
                className="col d-flex flex-column justify-content-center"
                key={index}
              >
                <figure className={padRange[index]}>
                  <img
                    src={client.sourceUrl}
                    alt={client.altText}
                    title={client.altText}
                  />
                </figure>
              </div>
            ) : (
              ""
            )
          )}
        </div>
      </div>
    </div>
  )
}

export default HomeClients
